import React, { useState } from "react";
import { Card, Button, Alert, Container, Row, Col } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, Redirect, useHistory } from "react-router-dom";

export default function Dashboard() {
    const [error, setError] = useState("");
    const { currentUser, logout } = useAuth();
    const history = useHistory();
    async function handleLogout() {
        setError("");

        try {
            await logout();
            history.push("/login");
        } catch {
            setError("Failed to log out");
        }
    }
    if (currentUser && !currentUser.displayName) {
        return <Redirect to="/update-profile" />;
    }
    return (
        <>
            <Card>
                <Card.Body>
                    <h2 className="text-center mb-4">Profile</h2>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <strong>Email:</strong> {currentUser.email}
                    <br />
                    <strong>Display Name:</strong> {currentUser.displayName}
                    <br />
                    <Link
                        to="/update-profile"
                        className="btn btn-primary w-100 mt-3"
                    >
                        Update Profile
                    </Link>
                </Card.Body>
                    <div className="w-100 text-center mt-2">
                        <Button variant="link" onClick={handleLogout}>
                            Log Out
                        </Button>
                    </div>
            </Card>
        </>
    );
}
